(function($){ $(function(){
    
    $('#billboard') 
	.before('<div id="billboardNav">') 
	.cycle({ 
	    fx: 'uncover', 
	    speed: 2000, 
	    timeout: 3000, 
	    pager: '#billboardNav',
		pause: true,
		pauseOnPagerHover: true,
		slideExpr: '.slide',
		cleartype: true,
		cleartypeNoBg: true
	});

}); })(jQuery)
